import noop from "lodash/noop";
import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { HeaderMenuLink } from "@Types/header";
import "./style.scss";

interface Props {
  accountLinks: HeaderMenuLink[];
}

const HeaderAccount: FunctionComponent<Props> = ({ accountLinks }) => {
  const intl = useIntl();

  return (
    <div className="HeaderAccount">
      {accountLinks.map(({ className, url, label, onclick }) => {
        return url ? (
          <a className={`HeaderAccount-link ${className ? className : ""}`} href={url} key={label}>
            {intl.formatMessage({ id: `cheerz_Header_${label}` })}
          </a>
        ) : (
          <div
            className={`HeaderAccount-link ${className ? className : ""}`}
            onClick={onclick ? onclick : noop}
            key={label}
          >
            {intl.formatMessage({ id: `cheerz_Header_${label}` })}
          </div>
        );
      })}
    </div>
  );
};

export default HeaderAccount;
